import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useCatalog = () => {
  const q = useQuery({
    queryKey: ["catalog"],
    queryFn: async () => (await api.get("/catalog")).data,
    retry: 1,
  });
  return {
    sectors: q.data?.sectors ?? {},
    products: Array.isArray(q.data?.products) ? q.data.products : [],
    documents: Array.isArray(q.data?.documents) ? q.data.documents : [],
    loading: q.isLoading,
    failed: q.isError,
  };
};
